import React, { useState, useEffect, useRef } from "react";
import { getToken, base_url } from "../config/config";

export const useTemplate = (templateId) => {
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = getToken();

  const loadTemplate = async () => {
    if (!templateId) return;
    setLoading(true);
    try {
      const response = await fetch(
        `${base_url}/v1/getInvoiceTemplatebyId/${templateId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await response.json();
      setTemplate(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const saveTemplate = async (templateData) => {
    try {
      const url = templateId
        ? `${base_url}/v1/updateInvoiceTemplate/${templateId}`
        : `${base_url}/v1/createInvoiceTemplate`;

      const response = await fetch(url, {
        method: templateId ? "PUT" : "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(templateData),
      });

      const data = await response.json();
      setTemplate(data);
      return data;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  useEffect(() => {
    loadTemplate();
  }, [templateId]);

  return { template, loading, error, saveTemplate };
};
